import { handleActions } from 'redux-actions';
import { SET_REDEEM_MILES, TOGGLE_REDEEM_MILES } from './actions';

export const redeemMilesReducer = handleActions<boolean, undefined | boolean>(
	{
		[TOGGLE_REDEEM_MILES]: (state: boolean) => {
			return !state;
		},
		[SET_REDEEM_MILES]: (state: boolean, action) => {
			return action.payload;
		}
	},
	false
);
